import { IconButton, Tooltip } from "@mui/material";
import { Star as LlenaIcon, StarBorder as VaciaIcon } from "@mui/icons-material";
import { tokens } from "../../theme";
import { useMarcarFavorito } from "../../queries/useTemas";

/**
 * La estrella de un tema: marca privada para volver a él después.
 *
 * No le avisa a nadie ni reserva nada, así que no pide confirmación y responde al
 * toque (la mutación es optimista). Dentro de una fila clicable se queda con el
 * clic y con la tecla: marcar no es entrar al tema.
 *
 * `tamano` acompaña al contexto —la fila del catálogo la lleva chica, la ficha
 * grande—, y el naranjo es el acento del kit: la única cosa marcada en la lista.
 */
export default function EstrellaFavorito({
  temaId,
  favorito,
  tamano = 20,
}: {
  temaId: number;
  favorito: boolean;
  tamano?: number;
}) {
  const marcar = useMarcarFavorito();

  return (
    <Tooltip title={favorito ? "Quitar de favoritos" : "Guardar en favoritos"}>
      <IconButton
        size="small"
        aria-label={favorito ? "Quitar de favoritos" : "Guardar en favoritos"}
        aria-pressed={favorito}
        onClick={(e) => {
          e.stopPropagation();
          marcar.mutate({ id: temaId, favorito: !favorito });
        }}
        onKeyDown={(e) => e.stopPropagation()}
        sx={{
          flexShrink: 0,
          color: favorito ? tokens.naranjo[400] : "text.disabled",
          "&:hover": { color: favorito ? tokens.naranjo[500] : tokens.naranjo[300] },
        }}
      >
        {favorito ? <LlenaIcon sx={{ fontSize: tamano }} /> : <VaciaIcon sx={{ fontSize: tamano }} />}
      </IconButton>
    </Tooltip>
  );
}
